import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import HomeHeader from "./HomeHeader";
import Hairstyle from "./Section/Hairstyle";
import MedicalFacility from "./Section/MedicalFacility";
import OutStandingBarber from "./Section/OutStandingBarber";
import HandBook from "./Section/HandBook";
import About from "./Section/About";
import HomeFooter from './HomeFooter'
import "./HomePage.scss";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class HomePage extends Component {
  render() {
    let settings = {
      // dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
    };
    return (
      <div>
        <HomeHeader isShowBanner={true}/>
        <Hairstyle settings={settings} />
        <MedicalFacility settings={settings} />
        <OutStandingBarber settings={settings} />
        <HandBook settings={settings} />
        <About />
        <HomeFooter/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.user.isLoggedIn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
